import React, { useContext, useEffect, useRef, useState } from "react";
import { fmDataContext } from "../../Context/FmData";
import Pagination from "../Pagination/Pagination";
import { Link } from "react-router-dom";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import GenreRow from "./GenreRow";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { fmGenresContext } from "../../Context/GenresContext";
import userCan from "../../helpers/userCan";
import { toast } from "react-toastify";

import GenresFiltration from "./GenresFiltration";

const Genres = () => {
  const isCalledRef = useRef(false);

  let { baseUrl, navigate, getData } = useContext(fmDataContext);

  let [genres, setGenres] = useState({});

  let [isGetGenresLoading, setIsGetGenresLoading] = useState(true);

  let [isPaginateLoading, setIsPaginateLoading] = useState(false);

  let [pageNum, setPageNum] = useState(1);

  let perPage = 20;
  let orderBy = "id";
  let orderType = "asc";

  let { genreMsg, setGenreMsg, filtrationDetails, isFiltrationLoading, setFiltrationDetails } = useContext(fmGenresContext);

  const getGenres = (reqMethod, pathName, params, setLoading = setIsGetGenresLoading, message = null) => {
    getData(reqMethod, pathName, params, setLoading)
      .then((response) => {
        setGenres(response.data);
        setLoading(false);
        if (genreMsg.length > 0) {
          toast(genreMsg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            progressStyle: { backgroundColor: "#fdb915" },
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "dark",
            onClose: () => setGenreMsg(""),
          });
        }
        if (message) {
          toast(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            progressStyle: { backgroundColor: "#fdb915" },
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      })
      .catch((error) => {
        navigate("/not-found");
      });
  };

  useEffect(() => {
    if (!isCalledRef.current) {
      getGenres(
        "GET",
        `${baseUrl}fm-genres`,
        {
          page_num: pageNum,
          per_page: perPage,
          order_type: orderType,
          order_by: orderBy,
        },
        setIsGetGenresLoading
      );
    }

    return () => {
      isCalledRef.current = true;
      setFiltrationDetails({
        search_query: "",
        only_trashed: 0,
      });
    };
  }, []);

  return (
    <>
      <div className="container">
        <div className={`${!isGetGenresLoading ? "min-vh-100" : ""}`}>
          <div className="mb-2 mb-sm-5">
            <div className="d-flex align-items-center justify-content-between mb-3 mt-3">
              <h1 className="page-heading-title mb-0">GENRES</h1>
              {userCan("fm_genre_create") ? (
                <div className="me-3">
                  <Link to="/fm-genres/create" className="fu-btn fu-btn-gray">
                    <span className="btn-bg"></span>
                    Create New
                  </Link>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="mt-4">
              <GenresFiltration getGenres={getGenres} perPage={perPage} orderBy={orderBy} orderType={orderType} />
            </div>
          </div>
          {!isGetGenresLoading ? (
            <>
              <div className="row py-3 d-none d-xxl-flex table-heading-brdr">
                <div className="col-md-1">
                  <h3 className="h6 mb-0 fu-text-white">#ID</h3>
                </div>
                <div className="col-md-3">
                  <h3 className="h6 mb-0 fu-text-white">KEY</h3>
                </div>
                <div className="col-md-2">
                  <h3 className="h6 mb-0 ms-2 fu-text-white">GENRE NAME</h3>
                </div>
                <div className="col-md-1">
                  <h3 className="h6 mb-0 fu-text-white">T-COUNT</h3>
                </div>
                <div className="col-md-1">
                  <h3 className="h6 mb-0 fu-text-white">V-COUNT</h3>
                </div>
                <div className="col-md-4">
                  <h3 className="h6 mb-0 fu-text-white">OPERATIONS</h3>
                </div>
              </div>
              <div className="table-heading-brdr mt-4 mt-sm-0 d-xxl-none"></div>
              {isPaginateLoading ? (
                <div className="d-flex justify-content-center mt-5">
                  <div className="position-relative mt-5">
                    <LoadingCircle circleCont={85} icon={80} loader={85} dot={85} />
                  </div>
                </div>
              ) : (
                <>
                  {genres.data && genres.data.length > 0 ? (
                    genres.data.map((genre, index) => <GenreRow key={index} meta={genres.meta} genre={genre} index={index} getGenres={getGenres} perPage={perPage} pageNum={pageNum} orderBy={orderBy} orderType={orderType} />)
                  ) : genres.data && genres.data.length === 0 && filtrationDetails.search_query === "" && filtrationDetails.only_trashed === 0 && !isFiltrationLoading ? (
                    <div className="d-flex flex-column justify-content-center align-items-center mt-5 pt-5 item-msg">
                      <div>
                        <h2 className="fu-text-3-rem fu-text-yellow">
                          <i className="bi bi-database-add"></i>
                        </h2>
                      </div>
                      <div>
                        <h3 className="h5 fu-text-light-gray">
                          There Are No Genres
                          {userCan("fm_genre_create") ? (
                            <>
                              ,
                              <Link to="/fm-genres/create" className="link-dashed ms-2">
                                Create New
                              </Link>
                            </>
                          ) : (
                            ""
                          )}
                        </h3>
                      </div>
                    </div>
                  ) : !isFiltrationLoading ? (
                    <div className="d-flex flex-column justify-content-center align-items-center mt-5 pt-5 item-msg">
                      <div>
                        <h2 className="fu-text-3-rem fu-text-yellow">
                          <i className="bi bi-search"></i>
                        </h2>
                      </div>
                      <div>
                        <h3 className="h5 fu-text-light-gray">There are no genres matching your search</h3>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="mt-5">{genres ? genres.meta && genres.meta.last_page !== 1 ? <Pagination pages={genres.meta.links} pagination={genres.meta} getItems={getGenres} pathName={"fm-genres"} filtrationDetails={filtrationDetails} setIsPaginateLoading={setIsPaginateLoading} setPageNum={setPageNum} per_page={perPage} order_by={orderBy} order_type={orderType} /> : "" : ""}</div>
                </>
              )}
            </>
          ) : (
            <LoadingScreen />
          )}
        </div>
      </div>
    </>
  );
};

export default Genres;
